import { Col, Form, Row, Input } from "antd";
import React, { useEffect, useState } from "react";
import SwitchToggle from "../../../../biblio/switch/SwitchToggle";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import Selects from "../../../../biblio/Selects/Selects";

const { TextArea } = Input;

interface OrphanCareProps {
  index: number;
  banks: any;
  form: any;
  orphan: any;
}

const OrphanCare = ({ index, banks, form, orphan }: OrphanCareProps) => {
  const [isHaveTalent, setIsHaveTalent] = useState<boolean>(false);
  const [isDeveloped, setIsDeveloped] = useState<boolean>(false);
  const [isRequired, setIsRequired] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (orphan.account_number && orphan.account_number != "") {
      const json: any = {};
      json[`account_number${index}`] = orphan.account_number;
      json[`bank_id${index}`] = {
        key: banks.filter((el: any) => el.name === orphan.bank_id)[0]?.id,
        value: banks.filter((el: any) => el.name === orphan.bank_id)[0]?.id,
        label: orphan.bank_id,
      };

      json[`account_owner${index}`] = orphan.account_owner;
      form.setFieldsValue({
        ...form.getFieldsValue(),
        ...json,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleInputChange = () => {
    const values = form.getFieldsValue([
      `account_number${index}`,
      `bank_id${index}`,
      `account_owner${index}`,
    ]);

    const isAnyFieldFilled = Object.values(values).some((value) => value);
    setIsRequired(isAnyFieldFilled);

    if (!isAnyFieldFilled) {
      form.validateFields([
        `account_number${index}`,
        `bank_id${index}`,
        `account_owner${index}`,
      ]);
    }
  };

  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], fieldName: string) => {
    const file = fileList[0]?.originFileObj;
    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };
        form.setFieldsValue({
          [fieldName]: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>الرعاية</span>
      </div>

      <Row dir="rtl" gutter={16} align="top">
        <Col xxl={6} xl={6} lg={6} md={24} sm={24} xs={24}>
          <Form.Item name={`have_talent${index}`}>
            <SwitchToggle
              className="takaful--beneficiary-update-switch"
              switchState={isHaveTalent}
              onSwitchChange={() => setIsHaveTalent(!isHaveTalent)}
              label="هل لديه موهبة؟"
            />
          </Form.Item>
          {isHaveTalent && (
            <Form.Item
              name={`talent_description${index}`}
              labelCol={{ className: "takaful--label-style" }}
            >
              <TextArea
                showCount
                maxLength={100}
                placeholder="موهبة يتميز بها"
                style={{ height: 70, resize: "none" }}
              />
            </Form.Item>
          )}
        </Col>

        <Col xxl={6} xl={6} lg={6} md={24} sm={24} xs={24}>
          <Form.Item name={`has_been_developed${index}`}>
            <SwitchToggle
              className="takaful--beneficiary-update-switch"
              switchState={isDeveloped}
              onSwitchChange={() => setIsDeveloped(!isDeveloped)}
              label="هل تمت تنميتها؟"
            />
          </Form.Item>
          {isDeveloped && (
            <Form.Item
              name={`reason_not_developing_talent${index}`}
              labelCol={{ className: "takaful--label-style" }}
            >
              <TextArea
                showCount
                maxLength={100}
                placeholder="سبب عدم تنمية الموهبة"
                style={{ height: 70, resize: "none" }}
              />
            </Form.Item>
          )}
        </Col>
      </Row>

      <div className="takaful--title-tabs-sub">
        <span>الحساب البنكي</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`account_number${index}`}
            label="رقم الحساب"
            className="takaful--label-inputs"
            rules={[{ required: isRequired, message: "الرجاء تعبئة الحقل" }]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="tel"
              onChange={handleInputChange}
              disabled={orphan.account_number && orphan.account_number !== ""}
            />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`bank_id${index}`}
            label="البنك"
            rules={[{ required: isRequired, message: "الرجاء تعبئة الحقل" }]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={banks}
              onChange={handleInputChange}
              allowClear
              disabled={orphan.bank_id && orphan.bank_id !== ""}
            />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`account_owner${index}`}
            label="صاحب الحساب"
            rules={[{ required: isRequired, message: "الرجاء تعبئة الحقل" }]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={handleInputChange}
              disabled={orphan.account_owner && orphan.account_owner !== ""}
            />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`attachment_ids${index}`}
            label="صورة رقم الايبان"
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="image/*"
              text="صورة رقم الايبان"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "guardian_acc_number_iban")
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default OrphanCare;
